import { render, staticRenderFns } from "./courseQuestionDetail.vue?vue&type=template&id=195c88f2&scoped=true"
import script from "./courseQuestionDetail.vue?vue&type=script&lang=js"
export * from "./courseQuestionDetail.vue?vue&type=script&lang=js"
import style0 from "./courseQuestionDetail.vue?vue&type=style&index=0&id=195c88f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195c88f2",
  null
  
)

export default component.exports